<div class="container mt-5" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="page-break-inside: avoid;">
    <div class="row">
        <div class="col-12 text-center">
            <strong> তফসিল ৫</strong> <br>
            বিনিয়োগজনিত কর রেয়াত দাবি করিলে নিম্নোক্ত তফসিলটি পূরণ করিতে হইবে (প্রামাণ্য দলিলাদি সংযুক্ত করিতে হইবে)
        </div>
    </div>

    <div class="row my-4 px-2">
        <div class="col-sm-5">
            করদাতার নাম: {{returnData?.profileData?.assesName}}
        </div>
        <div class="col-sm-7 text-right">
            টি আইএন: 
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item | convertNumWithOtherCharsToBn}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>
        
    <div class="row mt-4">
        <div class="col-6 pl-5">
            <strong> কর রেয়াতের জন্য প্রযোজ্য বিনিয়োগ বিবরণী :</strong>
        </div>
    </div>    

    <div class="row mt-2">
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td width="10%">১।</td>
                        <td width="60%">বাংলাদেশে পরিশোধিত জীবন বিমা পলিসির প্রিমিয়াম বা চুক্তিভিত্তিক Deferred Annuity
                        </td>
                        <td width="30%">{{data?.RB_CAT_LIFE_INS_PREM | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">২।</td>
                        <td width="60%">ডিপোজিট পেনশন/ মাসিক সঞ্চয় স্কিমে প্রদত্ত চাঁদা (অনুমোদনযোগ্য সীমার অতিরিক্ত
                            নহে)</td>
                        <td width="30%">{{data?.RB_CAT_DPS | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৩।</td>
                        <td width="60%">সরকারি সিকিউরিটিজ, ইউনিট সার্টিফিকেট, মিউচুয়াল ফান্ড, ইটিএফ অথবা যৌথ বিনিয়োগ
                            স্কিম ইউনিট সার্টিফিকেট বিনিয়োগ</td>
                        <td width="30%">{{savingAndUnitCertificate | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৪।</td>
                        <td width="60%">অনুমোদিত স্টক এক্সচেঞ্জের সহিত তালিকাভুক্ত কোন সিকিউরিটিজ বিনিয়োগ</td>
                        <td width="30%">{{data?.RB_CAT_APPR_STOCKS_OR_SHARES | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৫।</td>
                        <td width="60%">Provident Fund Act, 1925 এর বিধানাবলি প্রযোজ্য এইরুপ যেকোনো তহবিলে করদাতার চাঁদা
                        </td>
                        <td width="30%">{{data?.RB_CAT_GPF | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৬।</td>
                        <td width="60%">করদাতা ও তাহার নিয়োগকর্তা কর্তৃক অনুমোদিত ভবিষ্য তহবিলে প্রদত্ত চাঁদা </td>
                        <td width="30%">{{data?.RB_CAT_RPF | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৭।</td>
                        <td width="60%">অনুমোদিত বার্ধক্য তহবিলে প্রদত্ত চাঁদা </td>
                        <td width="30%">{{data?.RB_CAT_APPR_SUPER_ANNUATION_FUND | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৮।</td>
                        <td width="60%">কল্যাণ তহবিলে প্রদত্ত/ গোষ্ঠী বিমা তহবিলে প্রদত্ত চাঁদা </td>
                        <td width="30%">{{data?.RB_CAT_BENEVOLENT_FUND_GRP_INS_PREM | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">৯।</td>
                        <td width="60%">যাকাত তহবিলে প্রদত্ত চাঁদা </td>
                        <td width="30%">{{data?.RB_CAT_ZAKAT_FUND | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">১০।</td>
                        <td width="60%">অন্যান্য, যদি থাকে (বিবরণ দিন)</td>
                        <td width="30%">{{others | formatNumberReturnView}}</td>
                    </tr>
                    <tr>
                        <td width="10%">১১।</td>
                        <td width="60%">মোট বিনিয়োগ (ক্রমিক ১ হইতে ক্রমিক ১০ পর্যন্ত যোগফল)</td>
                        <td width="30%">
                            {{
                             totalInvestment | formatNumberReturnView
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td width="10%">১২।</td>
                        <td width="60%">কর রেয়াতের পরিমাণ </td>
                        <td width="30%">{{returnData?.taxPaymentData?.tc_Tax_Rebate_Amt | formatNumberReturnView}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>